<ui-notify
	type="warning"
	[showBottomPadding]="false"
	[text]="'ai_chat.default_assistant' | translate"
>
	<ui-button
		type="secondary"
		icon="load_forward"
		[text]="'ai_chat.retry' | translate"
		(buttonClicked)="retry.emit()"
	></ui-button>
</ui-notify>
